// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-range-span {
  position: relative;
  top: 38%;
  display: flex;
}

.select-range-span input {
  border-radius: none;
  border: none;
  width: fit-content;
  height: 24px;
}

.select-range-span span {
  display: flex;
  gap: 8px;
  justify-content: right;
  border-bottom: 1px solid var(--hover-color);
}

.rdrDateRangePickerWrapper .rdrDefinedRangesWrapper {
  background-color: transparent;
}
.rdrDateRangePickerWrapper .rdrDefinedRangesWrapper .rdrInputRanges {
  padding: 0;
}
.rdrDateRangePickerWrapper .rdrDateRangeWrapper {
  margin-top: 0;
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/DatePicker/DateRange.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;AAAJ;;AAGE;EACE,mBAAA;EACA,YAAA;EAEA,kBAAA;EACA,YAAA;AAAJ;;AAGE;EACE,aAAA;EACA,QAAA;EACA,sBAAA;EACA,2CAAA;AAAJ;;AAGI;EACE,6BAAA;AAAN;AACM;EACE,UAAA;AACR;AAEI;EACE,aAAA;EACA,gBAAA;AAAN","sourcesContent":["\n.select-range-span{\n    position: relative;\n    top: 38%;\n    display: flex;\n  }\n  \n  .select-range-span input {\n    border-radius: none;\n    border: none;\n    width: -moz-fit-content;\n    width: fit-content;\n    height: 24px;\n  }\n  \n  .select-range-span span{\n    display: flex;\n    gap: 8px;\n    justify-content: right;\n    border-bottom: 1px solid var(--hover-color);\n  }\n  .rdrDateRangePickerWrapper{\n    .rdrDefinedRangesWrapper{\n      background-color: transparent;\n      .rdrInputRanges{\n        padding: 0;\n      }\n    }\n    .rdrDateRangeWrapper{\n      margin-top: 0;\n      margin-left: 4px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
